import { useAudioState } from 'Services/Audio/useAudioState';

import { getAudioUrl } from './getAudioUrl';

import type { ArticleTypeT } from 'Constants/articleTypes';

export const useIsAudioPlaying = (
  id: string,
  articleType: ArticleTypeT,
  mpServicePlanId?: string,
): boolean => {
  const { paused, url } = useAudioState();
  const audioUrl = getAudioUrl(id, articleType, mpServicePlanId);

  return url === audioUrl && !paused;
};
